import BaseInfoBox from "../BaseInfoBox";
import HTPFourthPart from "../HTPFourthPart";

export default class HTPFourInARow extends BaseInfoBox {
  private HTPFourthPart = HTPFourthPart.getInstance();
  constructor() {
    super();
    this._addCoord();
    this.addBg(260, 130, 0x3d52c0, 0x4d62d0)
    this.addText("FOUR IN A ROW GETS YOU A FREE BONUS GAME!", 65, 240);
    this.addToCon();
    this.scale.set(this.startScale);
  } 
  _addCoord(){
    let x = -200;
    let y = 0;
    if (this.isVertical) {
      x = -130;
      y = 400
    }
    this.addCoord(x, y);
  }
  addToCon() {
    this.HTPFourthPart.addChild(this);
  }
}